module.exports = __webpack_public_path__ + "./Fergus_b54a5ed284cc8063236178bb82683d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Fergus.jpg
// module id = 476
// module chunks = 0